'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd-compat';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { getDefaultType, getDisplayName, getModuleIcon, getIsModuleEditable, makeGetCanCellBeCloned, makeGetCellOrRowParentId, getIsGlobalModuleGroupOrPartial, getModuleById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsAdvancedModuleWithoutAccess, getModuleHasPaymentsFieldWithoutAccess, getModuleHasPersonalizationTokensWithoutAccess } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsModuleStyleable } from 'ContentEditorUI/redux/selectors/styleSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { BaseResponsiveToolbar, buildActionsForModuleInDndArea } from './BaseResponsiveToolbar';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getIsInNonDefaultBreakpointMode, getIsInDefaultBreakpointMode, getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { shouldShowEditModuleOnSelected } from 'InpageEditorUI/lib/toolbarUtils';
import { getResponsiveToolbarPinLocation } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const dragSource = {
  beginDrag(props) {
    const {
      id,
      parentId,
      draggingStartedAndDeselectExisting,
      layoutSectionId,
      gridLayoutId,
      moduleIcon
    } = props;
    const dragItem = {
      dragId: id,
      dragParentId: parentId,
      isColumn: false,
      isRow: false,
      isTopMostRow: false,
      originLayoutSectionId: layoutSectionId || gridLayoutId,
      iconUrl: moduleIcon,
      dragType: dragTypes.EXISTING_ITEM
    };
    draggingStartedAndDeselectExisting(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return props.isInDefaultBreakpointMode;
  },
  endDrag(props, monitor) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
  }
};
function dragCollect(monitor) {
  return {
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = () => {
  const getCellOrRowParentId = makeGetCellOrRowParentId();
  const getCanCellBeCloned = makeGetCanCellBeCloned();
  return (state, ownProps) => {
    let newProps = {};
    if (ownProps.id) {
      const module = getModuleById(state, ownProps.id);
      newProps = {
        parentId: getCellOrRowParentId(state, {
          layoutSectionId: ownProps.layoutSectionId,
          id: ownProps.id
        }),
        canBeCloned: getCanCellBeCloned(state, {
          layoutSectionId: ownProps.layoutSectionId,
          id: ownProps.id
        }),
        moduleType: getDefaultType(state, ownProps.id),
        moduleIcon: getModuleIcon(state, ownProps.id),
        displayName: getDisplayName(state, ownProps.id),
        isGlobal: getIsGlobalModuleGroupOrPartial(state, ownProps.id),
        isEditable: getIsModuleEditable(state, ownProps.id),
        isStyleable: getIsModuleStyleable(state, ownProps.id),
        isInNonDefaultBreakpointMode: getIsInNonDefaultBreakpointMode(state),
        isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
        activeBreakpointName: getActiveBreakpointName(state),
        isAdvancedModuleWithoutAccess: getIsAdvancedModuleWithoutAccess(state, module),
        isPaymentsModuleWithoutAccess: getModuleHasPaymentsFieldWithoutAccess(state, module),
        hasPersonalizationTokenWithoutAccess: getModuleHasPersonalizationTokensWithoutAccess(state, module),
        selectedItemId: getSelectedItemId(state),
        isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state)
      };
    } else {
      newProps.isAdvancedModuleWithoutAccess = false;
      newProps.isPaymentsModuleWithoutAccess = false;
      newProps.hasPersonalizationTokenWithoutAccess = false;
    }
    newProps.isInNonDefaultBreakpointMode = getIsInNonDefaultBreakpointMode(state);
    return newProps;
  };
};
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction
};
class ResponsiveToolbarInDndAreaComponent extends Component {
  componentDidMount() {
    const {
      connectDragPreview
    } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  render() {
    const {
      id,
      layoutSectionId,
      gridLayoutId,
      displayName,
      moduleType,
      moduleIcon,
      top,
      left,
      toolbarHeight,
      onHandleMouseDown,
      onDropdownOpenChange,
      responsiveSize,
      dispatch,
      bus,
      connectDragSource,
      isGlobal,
      isEditable,
      isStyleable,
      isInNonDefaultBreakpointMode,
      activeBreakpointName,
      isFixedPosition,
      canBeCloned,
      isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess,
      selectedItemId,
      isPatagoniaSidebarCollapsed,
      isCommentable
    } = this.props;
    const showEditModuleOnSelected = shouldShowEditModuleOnSelected({
      isPatagoniaSidebarCollapsed,
      moduleType
    });
    return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
      position: isFixedPosition ? 'fixed' : 'absolute',
      moduleIcon: moduleIcon,
      pinLocation: getResponsiveToolbarPinLocation(top, toolbarHeight, id === selectedItemId),
      actions: buildActionsForModuleInDndArea({
        moduleId: id,
        layoutSectionId,
        gridLayoutId,
        isInNonDefaultBreakpointMode,
        activeBreakpointName,
        canBeCloned,
        moduleType,
        dispatch,
        bus,
        isGlobal,
        isEditable,
        isStyleable,
        isAdvancedModuleWithoutAccess,
        isPaymentsModuleWithoutAccess,
        hasPersonalizationTokenWithoutAccess,
        isCommentable
      }),
      isSelectedItem: id === selectedItemId,
      isGlobal: isGlobal,
      onHandleMouseDown: onHandleMouseDown,
      onDropdownOpenChange: onDropdownOpenChange,
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`,
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      connectDragSource: connectDragSource,
      isAdvancedModuleWithoutAccess: isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess: isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess: hasPersonalizationTokenWithoutAccess,
      showEditModuleOnSelected: showEditModuleOnSelected,
      moduleId: id,
      isCommentable: isCommentable
    });
  }
}
ResponsiveToolbarInDndAreaComponent.propTypes = {
  id: PropTypes.string,
  layoutSectionId: PropTypes.string,
  moduleType: PropTypes.string,
  moduleIcon: PropTypes.string,
  displayName: PropTypes.string,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  toolbarHeight: PropTypes.number,
  responsiveSize: PropTypes.string.isRequired,
  activeBreakpointName: PropTypes.string,
  onHandleMouseDown: PropTypes.func,
  onDropdownOpenChange: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  isGlobal: PropTypes.bool,
  isEditable: PropTypes.bool,
  isStyleable: PropTypes.bool,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isFixedPosition: PropTypes.bool,
  canBeCloned: PropTypes.bool,
  isAdvancedModuleWithoutAccess: PropTypes.bool,
  isPaymentsModuleWithoutAccess: PropTypes.bool,
  hasPersonalizationTokenWithoutAccess: PropTypes.bool,
  selectedItemId: PropTypes.string,
  isPatagoniaSidebarCollapsed: PropTypes.bool,
  isCommentable: PropTypes.bool
};
ResponsiveToolbarInDndAreaComponent.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE
};
export default connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(ResponsiveToolbarInDndAreaComponent));